import React from 'react';

const StreamingCursor = () => (
    <span className="ml-0.5 inline-block h-4 w-1.5 animate-pulse bg-current align-middle opacity-70" />
);

export default StreamingCursor;
